module.exports = __webpack_public_path__ + "img/1559078895.cd4ca50e.jpg";